<template>
  <v-container>
    <v-row>
      <v-col cols="auto">
        <v-icon size="large" icon="mdi-chart-timeline-variant" color="dark-cyan"></v-icon>
      </v-col>
      <v-col align-self="center">
        <h2 class="itemis-analyze-title"> {{ labels.CUSTOM_METRIC.CUSTOM_METRICS }} </h2>
      </v-col>
    </v-row>
    <custom-metrics-list :has-apply-action="false" @edit="editMetric" />
  </v-container>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import CustomMetricsList from '@/pages/project/CustomMetricsList.vue'
  import labels from '@/translations/labels.json'
  import { useProjectStore } from '@/stores/projectStore'
  import { storeToRefs } from 'pinia'
  import { CustomMetric, Toolbox } from '@/models/custom-metric.model'
  import { EventBus } from '@/event-bus'
  import { ServiceKeys } from '@/services/symbols'
  import { injectTyped } from '@/inject'
  import { useRouter } from 'vue-router'

  const router = useRouter()
  const customMetricService = injectTyped(ServiceKeys.customMetrics)
  const blockingWork = ref<boolean>(false)

  EventBus.on('createNewCustomMetric', showCreateNewCustomMetric)
  EventBus.on('openCustomMetricToEdit', openCustomMetricToEdit)

  const projectStore = useProjectStore()

  const { currentProject } = storeToRefs(projectStore)

  const toolbox = ref<Toolbox>({})

  watch([currentProject], async () => {
    updateToolbox()
  })

  async function doBlocking(work: () => void) {
    blockingWork.value = true
    try {
      work.apply(undefined)
    } finally {
      blockingWork.value = false
    }
  }

  async function updateToolbox() {
    await doBlocking(async () => {
      const projectId = currentProject.value?.id
      if (projectId) {
        const newToolbox = await customMetricService.getToolbox(projectId, toolbox.value)
        if (projectId === currentProject.value?.id) {
          toolbox.value = newToolbox
        }
      }
    })
  }

  function editMetric(metric: CustomMetric) {
    router.push({ name: labels.CUSTOM_METRIC.CUSTOM_METRIC, params: { customMetricId: metric.id } })
  }
  function showCreateNewCustomMetric() {
    const path = router.currentRoute.value.path + '/-1'
    router.push({ path })
  }

  function openCustomMetricToEdit(metric: CustomMetric) {
    editMetric(metric)
  }
</script>

<style scoped>
  .left-align-fields {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .inline-header-container {
    display: inline-flex;
    align-items: center;
  }

  .edit-icon {
    margin-left: 10px;
  }

  .primary-btn {
    background-color: rgb(var(--v-theme-cyan-dark));
    color: rgb(var(--v-theme-surface));
  }

  .secondary-btn {
    background-color: rgb(var(--v-theme-itemis-hidden-grey));
    color: rgb(var(--v-theme-surface));
  }

  .flexible-container {
    display: flex;
    width: 100%;
  }

  .fixed-toolbox {
    flex: 0 0 300px;
    margin-right: 20px;
    border: 2px solid #eaeaea;
    padding: 25px;
  }

  .flexible-table {
    flex: 1;
    overflow-x: auto;
    border: 2px solid #eaeaea;
    padding: 25px;
  }

  .action-btn {
    width: 180px;
  }

  .v-container {
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    .action-btn {
      width: 100%;
      margin-top: 10px;
    }
  }
</style>
